import { parseQuery } from './url';

function canLog(): boolean {
  // eslint-disable-next-line no-console
  return console?.log !== undefined;
}

function logQuery(): string[] | undefined {
  if (window?.location?.search) {
    const parsed = parseQuery(window.location.search);

    return parsed.log;
  }

  return undefined;
}

export function log(message?: unknown, ...optionalParams: unknown[]): void {
  const query = logQuery();

  if (!canLog() || query === undefined) {
    return;
  }

  if (
    query.length === 0 ||
    (typeof message === 'string' && query.indexOf(message) !== -1)
  ) {
    // eslint-disable-next-line no-console
    console.log(message, ...optionalParams);
  }
}
